import React from 'react';
import { ShieldCheck, Truck, PenTool } from 'lucide-react';
export const TrustBar = () => {
  const features = [{
    icon: ShieldCheck,
    text: 'Authenticated & Graded'
  }, {
    icon: Truck,
    text: 'Fast Insured Shipping'
  }, {
    icon: PenTool,
    text: 'Verified Autographs'
  }];
  return <div className="bg-ink text-white py-4 border-t border-white/10" data-id="element-140">
      <div className="container mx-auto px-4" data-id="element-141">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-142">
          {features.map((feature, idx) => <div key={idx} className="flex items-center justify-center space-x-2" data-id="element-143">
              <feature.icon className="w-5 h-5 text-scarlet flex-shrink-0" data-id="element-144" />
              <span className="text-xs md:text-sm font-bold uppercase tracking-wider text-center" data-id="element-145">
                {feature.text}
              </span>
            </div>)}
        </div>
      </div>
    </div>;
};